// AUTO-GENERATED by scripts/set-env.js — do not edit by hand.
// Values come from .env (local) or deploy env vars. Edit .env / .env.example instead.
export const environment = {
  "production": false,
  "GoogleClientID": "35900800300-a2us1mp97alcpqh41vfdr2j6b54dkumr.apps.googleusercontent.com",
  "MicrosoftClientID": "5790a438-1279-4acd-87ec-a9fd50a2a728",
  "stripeKey": "pk_test_TtOq7HAX31aJolrlOiZR9Guu",
  "siteName": "Let's Time IT",
  "pusherKey": "d13751c49ac3cdf4fceb",
  "frontendUrl": "https://dev.letstimeit.com/",
  "backendUrl": "https://apidev.letstimeit.com"
};
